import DefaultLayout from "../layout/DefaultLayout";
import DocumentPreviewPage from "../pages/documents/DocumentPreviewPage";
import HomePage from "../pages/HomePage";
import { LoginPage } from "../pages/LoginPage";
import ProfilePageLayout from "../layout/ProfilePageLayout";
import { RegisterPage } from "../pages/RegisterPage";
import SearchDocsPage from "../pages/documents/SearchDocsPage";
import SubmitDocsPage from "../pages/documents/SubmitDocsPage";
import PersonalInfoPage from "../pages/profile/PersonalInfoPage";
import AdminPageLayout from "../layout/AdminPageLayout";
import AdminUsersPage from "../pages/AdminUsersPage";
import AdminUserEditPage from "../pages/AdminUserEditPage";
import AdminDocumentPage from "../pages/AdminDocumentsPage";
import AdminPermissionsPage from "../pages/AdminPermissionsPage";
import SubscriptionSettingPage from "../pages/profile/SubscriptionSettingPage";
import PaymentSettingPage from "../pages/profile/PaymentSettingPage";
import UploadedDocumentsPage from "../pages/profile/UploadedDocumentsPage";
import { AdminAddUserPage } from "../pages/AdminAddUserPage";
import AdminEmailAlertsPage from "../pages/AdminEmailAlertsPage";
import SubmitUrlPage from "../pages/urls/SubmitUrlPage";
import SearchUrlPage from "../pages/urls/SearchUrlPage";
import UrlPreviewPage from "../pages/urls/UrlPreviewPage";
import AdminAboutUsEdit from "../pages/AdminEditPage";
import { ForgotPasswordPage } from "../pages/ForgotPasswordPage";
import AdminSubmitNewsPage from "../pages/news/AdminSubmitNewsPage";
import AdminNewsPage from "../pages/news/AdminNewsPage";
import NewsPreviewPage from "../pages/news/NewsPreviewPage";
import AdminEditNewsPage from "../pages/news/AdminEditNewsPage";
import SearchNewsPage from "../pages/news/SearchNewsPage";
import { AboutUsPage } from "../pages/AboutUsPage";
import AdminAppPages from "../pages/AdminAppPages";
import AdminEditPage from "../pages/AdminEditPage";
import { DisclaimerPage } from "../pages/DisclaimerPage";
import { PrivacyPage } from "../pages/PrivacyPage";
import { ConditionsPage } from "../pages/ConditionsPage";
import MessagesPage from "../pages/MessagesPage";
import NewMessagePage from "../pages/NewMessagePage";
import AdminApproveUrlPage from "../pages/AdminApproveUrlPage";
import AdminListPage from "../pages/AdminListPage";
import { DeleteAccountPage } from "../pages/DeleteAccountPage";

const routes = [
	{
		path: "/",
		auth: false,
		exact: true,
		Component: HomePage,
		Layout: DefaultLayout,
	},
	{
		path: "/signin",
		auth: false,
		exact: true,
		Component: LoginPage,
		Layout: DefaultLayout,
	},
	{
		path: "/register",
		auth: false,
		exact: true,
		Component: RegisterPage,
		Layout: DefaultLayout,
	},
	{
		path: "/forgot-password",
		auth: false,
		exact: true,
		Component: ForgotPasswordPage,
		Layout: DefaultLayout,
	},
	{
		path: "/submit-your-best-practice",
		auth: true,
		exact: true,
		Component: SubmitDocsPage,
		Layout: DefaultLayout,
	},
	{
		path: "/search-best-practice",
		auth: false,
		exact: true,
		Component: SearchDocsPage,
		Layout: DefaultLayout,
	},
	{
		path: "/best-practice/:id",
		auth: false,
		exact: true,
		Component: DocumentPreviewPage,
		Layout: DefaultLayout,
	},
	{
		path: "/news",
		auth: false,
		exact: true,
		Component: SearchNewsPage,
		Layout: DefaultLayout,
	},
	{
		path: "/news/:id",
		auth: false,
		exact: true,
		Component: NewsPreviewPage,
		Layout: DefaultLayout,
	},
	
	{
		path: "/profile/info",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><ProfilePageLayout>{children}</ProfilePageLayout></DefaultLayout>,
		Component: PersonalInfoPage,
	},
	{
		path: "/profile/subscription",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><ProfilePageLayout>{children}</ProfilePageLayout></DefaultLayout>,
		Component: SubscriptionSettingPage,
	},
	{
		path: "/profile/messages",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><ProfilePageLayout>{children}</ProfilePageLayout></DefaultLayout>,
		Component: MessagesPage,
	},
	{
		path: "/profile/payment",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><ProfilePageLayout>{children}</ProfilePageLayout></DefaultLayout>,
		Component: PaymentSettingPage,
	},
	{
		path: "/profile/uploaded-documents",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><ProfilePageLayout>{children}</ProfilePageLayout></DefaultLayout>,
		Component: UploadedDocumentsPage,
	},
	{
		path: "/dashboard/messages",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><AdminPageLayout>{children}</AdminPageLayout></DefaultLayout>,
		Component: MessagesPage,
	},
	{
		path: "/dashboard/messages/new",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><AdminPageLayout>{children}</AdminPageLayout></DefaultLayout>,
		Component: NewMessagePage,
	},
	{
		path: "/dashboard/users",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><AdminPageLayout>{children}</AdminPageLayout></DefaultLayout>,
		Component: AdminUsersPage,
	},
	{
		path: "/dashboard/users/:id",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><AdminPageLayout>{children}</AdminPageLayout></DefaultLayout>,
		Component: AdminUserEditPage,
	},
	{
		path: "/dashboard/new-user",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><AdminPageLayout>{children}</AdminPageLayout></DefaultLayout>,
		Component: AdminAddUserPage,
	},
	{
		path: "/dashboard/best-practices",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><AdminPageLayout>{children}</AdminPageLayout></DefaultLayout>,
		Component: AdminDocumentPage,
	},
	{
		path: "/dashboard/approve-url",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><AdminPageLayout>{children}</AdminPageLayout></DefaultLayout>,
		Component: AdminApproveUrlPage,
	},
	{
		path: "/dashboard/permissions",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><AdminPageLayout>{children}</AdminPageLayout></DefaultLayout>,
		Component: AdminPermissionsPage,
	},
	{
		path: "/dashboard/pages",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><AdminPageLayout>{children}</AdminPageLayout></DefaultLayout>,
		Component: AdminAppPages,
	},
	{
		path: "/dashboard/edit-page/:keyName",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><AdminPageLayout>{children}</AdminPageLayout></DefaultLayout>,
		Component: AdminEditPage,
	},
	{
		path: "/dashboard/news",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><AdminPageLayout>{children}</AdminPageLayout></DefaultLayout>,
		Component: AdminNewsPage,
	},
	{
		path: "/dashboard/news/:id",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><AdminPageLayout>{children}</AdminPageLayout></DefaultLayout>,
		Component: NewsPreviewPage,
	},
	{
		path: "/dashboard/add-news",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><AdminPageLayout>{children}</AdminPageLayout></DefaultLayout>,
		Component: AdminSubmitNewsPage,
	},
	{
		path: "/dashboard/edit-news/:id",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><AdminPageLayout>{children}</AdminPageLayout></DefaultLayout>,
		Component: AdminEditNewsPage,
	},
	{
		path: "/dashboard/admins",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout><AdminPageLayout>{children}</AdminPageLayout></DefaultLayout>,
		Component: AdminListPage,
	},
	{
		path: "/submit-url",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout>{children}</DefaultLayout>,
		Component: SubmitUrlPage,
	},
	{
		path: "/search-url",
		auth: true,
		exact: true,
		Layout: ({ children }) => <DefaultLayout>{children}</DefaultLayout>,
		Component: SearchUrlPage,
	},
	{
		path: "/url/:id",
		auth: false,
		exact: true,
		Layout: ({ children }) => <DefaultLayout>{children}</DefaultLayout>,
		Component: UrlPreviewPage,
	},
	{
		path: "/about-us",
		auth: false,
		exact: true,
		Component: AboutUsPage,
		Layout: DefaultLayout,
	},
	{
		path: "/disclaimer",
		auth: false,
		exact: true,
		Component: DisclaimerPage,
		Layout: DefaultLayout,
	},
	{
		path: "/privacy",
		auth: false,
		exact: true,
		Component: PrivacyPage,
		Layout: DefaultLayout,
	},
	{
		path: "/conditions",
		auth: false,
		exact: true,
		Component: ConditionsPage,
		Layout: DefaultLayout,
	},
	{
		path: "/delete-account",
		auth: false,
		exact: true,
		Component: DeleteAccountPage,
		Layout: DefaultLayout,
	},
];

export default routes;